<template>
  <MainLayout ref="mainLayoutRef">
    <div class="dashboard-content">
      <div class="welcome-section">
        <h1>Welcome to <span class="highlight">Prec8</span></h1>
        <p class="subtitle">Recognize and celebrate your team's achievements</p>
      </div>

      <div class="decoration">
        <div class="floating-card card-1">
          <span class="emoji">🌟</span>
          <p>Keep up the great work!</p>
        </div>
        <div class="floating-card card-2">
          <span class="emoji">🚀</span>
          <p>Ready to recognize others?</p>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import MainLayout from './components/MainLayout.vue'

const mainLayoutRef = ref()

// Expose refresh function for parent components
defineExpose({
  refreshStats: () => mainLayoutRef.value?.refreshStats()
})
</script>

<style scoped>
.dashboard-content {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.welcome-section {
  text-align: center;
  margin-bottom: 3rem;
}

h1 {
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 1rem;
  color: #1a1a1a;
}

.highlight {
  background: linear-gradient(120deg, #FF6B6B 0%, #FF8E53 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.subtitle {
  font-size: 1.25rem;
  color: #666;
}

.decoration {
  position: relative;
  height: 200px;
}

.floating-card {
  position: absolute;
  background: white;
  padding: 1rem;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
}

.card-1 {
  top: 20%;
  right: 10%;
  transform: rotate(10deg);
  animation: float 6s ease-in-out infinite;
}

.card-2 {
  bottom: 20%;
  left: 10%;
  transform: rotate(-10deg);
  animation: float 6s ease-in-out infinite;
  animation-delay: -3s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(10deg);
  }
  50% {
    transform: translateY(-10px) rotate(10deg);
  }
}

@media (max-width: 768px) {
  .dashboard-content {
    padding: 1rem;
  }
  
  h1 {
    font-size: 2rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
  
  .decoration {
    display: none;
  }
}
</style>
